<template>
  <div class="body-box marginBox">
    <el-row class="plan"  :gutter="20">
      <el-tabs v-model="activeName" @tab-click="btnStatus">
        <el-tab-pane label="全部" name="ALL"></el-tab-pane>
        <el-tab-pane label="球场" name="COURT"></el-tab-pane>
        <el-tab-pane label="旅行" name="TRAVEL"></el-tab-pane>
        <el-tab-pane label="比赛" name="RACE"></el-tab-pane>
        <el-tab-pane label="已处理" name="PASS"></el-tab-pane>
        <el-tab-pane label="未处理" name="UNPROCESSED"></el-tab-pane>
      </el-tabs>

      <el-col :span='5'>
        <search-input v-model="queryInfo.userName" placeholder='blueTeeID/昵称/备注' @change="handleQuery"/>
      </el-col>
      <el-col :span='5'>
        <search-input v-model="queryInfo.orderNo" placeholder='订单号' @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 120px)'" :data="orderList" class="button-box">
      <el-table-column label="订单编号" prop="orderNo"></el-table-column>
      <el-table-column label="申请时间">
        <template slot-scope="scope">
          {{scope.row.createDatetime | formatDate}}
        </template>
      </el-table-column>
      <el-table-column label="修改类型">
        <template slot-scope="scope">
          {{scope.row.enumCancelType | SaleType}}
        </template>
      </el-table-column>
      <el-table-column label="修改人" prop="userInfo.name"></el-table-column>
      <el-table-column label="修改次数" prop="total"></el-table-column>
      <el-table-column label="状态" prop="handleStatus">
        <template slot-scope="scope">
          <span :style="{color: [scope.row.handleStatus === 'PASS' ? 'green' : scope.row.handleStatus === 'UNPROCESSED' ? '' : 'red']}">{{scope.row.handleStatus === 'PASS' ? '已处理' : scope.row.handleStatus === 'UNPROCESSED' ? '未处理' : '已驳回'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="cancelOrder(scope.row)">取消</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getOrderList"></pagination></div>

  </div>
</template>

<script>
import SearchInput from '@/components/common/searchInput/searchInput'
import { cancelOrders, cancelOrdersStatusByOrderId } from '@/api/order/order'
import Pagination from '@/components/common/Pagination/index'

export default {
  name: "modifyOrderList",
  components: {Pagination, SearchInput},
  data () {
    return {
      activeName: 'ALL',
      orderList: [],
      queryInfo: {
        enumType: 'CANCEL',
        enumCancelType: '',
        handleStatus: '',
        userName: '',
        orderNo: ''
      },
      cancelId: ''
    }
  },

  watch: {
    queryInfo(newData) {
      if (newData.enumCancelType === '' && !newData.handleStatus) {
        this.activeName = 'ALL'
      }
      if (newData.enumCancelType) {
        this.activeName = newData.enumCancelType
      }

      if (newData.handleStatus) {
        this.activeName = newData.handleStatus
      }

    }
  },

  created() {
    this.handleQuery()
  },

  methods: {
    //获取列表
    getOrderList (page, cb) {
      cancelOrders(page).then(res =>{
        this.orderList = cb(res)
      })
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    //按钮切换
    btnStatus(val) {
      if (val.name === 'PASS' || val.name === 'UNPROCESSED') {
        this.queryInfo.enumCancelType = ''
        this.queryInfo.handleStatus = val.name
      }else {
        this.queryInfo.enumCancelType = val.name === 'ALL' ? '' : val.name
        this.queryInfo.handleStatus = ''
      }
      this.handleQuery()
    },

    cancelOrder(row) {
      this.$confirm('是否取消这个订单, 是否继续?', '取消订单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          enumType: 'CANCEL',
          handleStatus: 'PASS'
        }
        cancelOrdersStatusByOrderId(row.orderId, data).then(res => {
          if (res.code === '0') {
            this.$message.success('执行成功!')
            this.handleQuery()
          }
        })
      }).catch(() => {})

    },

    cancelOrderStatus() {

    }

  }
}
</script>

<style scoped>

</style>
